import axiosClient from "../../../../../system/helpers/axiosConfig";

export const getTranslation = (id) => {
  return axiosClient.get(`api/translations/show-new/${id}`).then((r) => r.data);
};
